// Custom product launch UI: live countdowns for product-card coming soon overlays.
(function () {
  const countdowns = document.querySelectorAll('[data-custom-launch-countdown]');

  if (!countdowns.length) {
    return;
  }

  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  const updateCountdown = (element) => {
    const launchTimestamp = Number(element.getAttribute('data-launch-timestamp'));
    const target = Number.isFinite(launchTimestamp) ? launchTimestamp * 1000 : NaN;

    if (Number.isNaN(target)) {
      element.textContent = '00D:00H:00M:00S';
      return;
    }

    const remaining = Math.max(0, target - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    element.textContent = `${pad(days)}D:${pad(hours)}H:${pad(minutes)}M:${pad(seconds)}S`;
  };

  countdowns.forEach(updateCountdown);

  window.setInterval(() => {
    countdowns.forEach(updateCountdown);
  }, 1000);
})();
